import {
  Box,
  Button,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  ArrowLeft,
  DotsThreeVertical,
  PencilSimple,
  TrashSimple,
} from '@phosphor-icons/react';
import { useState } from 'react';
import { HeaderContainer } from '../../dashboard/AgentInfoHeader';

interface BrandDetailsHeaderProps {
  brandName: string;
  onBack: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const BrandDetailsHeader = ({
  brandName,
  onBack,
  onEdit,
  onDelete,
}: BrandDetailsHeaderProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    if (onEdit) onEdit();
  };

  const handleDelete = () => {
    handleMenuClose();
    if (onDelete) onDelete();
  };

  return (
    <HeaderContainer>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button
            onClick={onBack}
            sx={{
              minWidth: 'auto',
              p: 0,
              color: 'text.primary',
              '&:hover': { backgroundColor: 'transparent' },
            }}
          >
            <ArrowLeft size={24} />
          </Button>
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'DM Sans',
              fontWeight: 600,
              fontSize: '24px',
              lineHeight: '100%',
              letterSpacing: '-0.01em',
              color: '#2B2D3F',
            }}
          >
            {brandName}
          </Typography>
        </Box>

        <IconButton
          onClick={handleMenuOpen}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
          }}
        >
          <DotsThreeVertical size={24} />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
              borderRadius: '8px',
              mt: 1,
            },
          }}
        >
          <MenuItem
            onClick={handleEdit}
            sx={{
              fontSize: '14px',
              gap: 1,
              py: 1,
              px: 2,
            }}
          >
            <PencilSimple size={16} />
            Edit
          </MenuItem>
          <MenuItem
            onClick={handleDelete}
            sx={{
              fontSize: '14px',
              gap: 1,
              py: 1,
              px: 2,
              color: '#E74C3C',
            }}
          >
            <TrashSimple size={16} />
            Delete
          </MenuItem>
        </Menu>
      </Box>
    </HeaderContainer>
  );
};

export default BrandDetailsHeader;
